import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * This component breakes text by \n (line-break) into a bunch of spans.
 * It allows us to use one-line translation without breaking them down on separate strings.
 */
@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextComponent implements OnChanges {
  private _builtSpans: string[];

  get builtSpans(): string[] {
    return this._builtSpans;
  }

  @Input()
  text: string;

  @Input()
  textParameters: any;

  @Input()
  shouldTranslate = true;

  constructor(private translateService: TranslateService, private cd: ChangeDetectorRef) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (this.text && ('text' in changes || 'textParameters' in changes)) {
      if (this.shouldTranslate) {
        this._builtSpans = await firstValueFrom(this.translateService
          .get(this.text, this.textParameters)
          .pipe(map((res) => this.buildSpans(res))));
      } else {
        this._builtSpans = this.buildSpans(this.text);
      }
      
      this.cd.detectChanges();
    }
  }

  private buildSpans(translatedText: string): string[] {
    if (typeof translatedText === 'string') {
      return translatedText?.split('\n');
    }

    return [translatedText];
  }
}
